export const requiredInfoLabel = 'REQUIRED INFO TYPE';
export const requiredInfoPlaceholder = 'Required info...';
export const requiredInfoHelp = 'This is what tells an option if it should require additional info to be collected.';
export const requiredInfoPromptPlaceholder = 'This is the placeholder text for what they should type in the required info box...';
export const requiredInfoPromptLabel = 'REQUIRED INFO PLACEHOLDER';
